import { Injectable } from '@angular/core';
// import { ApiService } from '../home/_service/api.service';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Router} from '@angular/router';
import { of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { MetaService } from '@ngx-meta/core';
import { ApiService } from '../_services/api.service';
import { LocalizeRouterService } from 'localize-router';
import { TranslateService } from '@ngx-translate/core';
import { SearchSchede } from './card-list.resolver';
import { environment } from '../../../environments/environment';

@Injectable()
export class RicercaResolver implements Resolve<any> {

  constructor(
    private apiService: ApiService,
    private localize: LocalizeRouterService,
    private translate: TranslateService,
    private router: Router,
    private meta: MetaService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // tslint:disable-next-line: max-line-length
    const testoRicerca = this.router.getCurrentNavigation().extras.state ? this.router.getCurrentNavigation().extras.state.testoRicerca : null;
    console.log( 'RicercaResolver -> ', this.translate.currentLang, 'Testo ricerca ->', testoRicerca );
    this.meta.setTag('robots', 'noindex');
    return of({});
  }

}
